import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context/src/app-context';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { StockStatus } from 'src/components/stock-status';
import { StockStatusStates } from 'src/components/stock-status/types';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import { MediumUp, StockStatusWrapper } from './styles';

interface IStockBadge {
  status?: StockStatusStates | null;
  statusText?: string | null;
  showLabel?: boolean;
}

export const StockBadge: React.FC<IStockBadge> = props => {
  const { t } = useAppContext();

  const { status, statusText, showLabel = true } = props;

  const processedStatusText = statusText
    ? statusText.replace(/-/g, '\u2011') /* no-breaking hyphen in dates */
    : t(
        'product',
        `stock-status.${status ||
          'unknown'}` as keyof ParamsAndReturnTypes['product']
      );

  return (
    <StockStatusWrapper>
      <StockStatus
        status={status}
        tooltip={processedStatusText as string}
        tooltipPlacement="top"
      />
      {showLabel && (
        <MediumUp>
          <CaptionText emphasis={FontEmphasis.MEDIUM}>
            {processedStatusText}
          </CaptionText>
        </MediumUp>
      )}
    </StockStatusWrapper>
  );
};
